import React, { useEffect, useState } from 'react'
import { getWishlist, deleteWishlist } from '../Redux/ActionCreator/WishlistActionCreator'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import UserSidebar from './Partial/UserSidebar'
import Menubar from './Partial/Menubar'

export default function Wishlist() {
    let [wishlist, setWishlist] = useState([])
    let dispatch = useDispatch()

    let WishlistStateData = useSelector(state => state.WishlistStateData)

    function deleteItem(_id) {
        if (window.confirm("Are You really want to remove that item from cart")) {
            dispatch(deleteWishlist({ _id: _id }))
        }
    }

    useEffect(() => {
        (() => {
            dispatch(getWishlist())
            if (WishlistStateData.length) {
                setWishlist(WishlistStateData);
            }
            else
                setWishlist([])
        })()

    }, [WishlistStateData.length])

    return (
        <>
            <Menubar title="Wishlist Page" />
            <div className="container mt-3">
                <div className="row">
                    <div className="col-md-3">
                        <UserSidebar />
                    </div>
                    <div className="col-md-9">
                        <div className="testimonial-item img-border-radius shadow-sm bg-white mb-3">
                            <h4 className='px-4 pt-4'>My Wishlish</h4>
                            <hr />
                            {wishlist.length ?
                                wishlist.map((item, index) => {
                                    return <> <div key={index} className="row px-4">
                                        <div className="col-md-4">
                                            <Link to={`/product/${item?.product?._id}`}><img src={`${item.product?.pic}`} height={150} width="50%" alt={item?.product?.name} /></Link>
                                        </div>
                                        <div className='col-md-8'>
                                            <div className='d-flex justify-content-between'>
                                                <div><h6>{item.product?.name}</h6>
                                                    <p className='extra'>{item.product?.color}, {item.product?.size}</p>
                                                    <p className='extra'><del>&#8377; {item.product?.basePrice}</del> &#8377; {item.product?.finalPrice}<sup className='text-success'> {item.product?.discount}% Off</sup></p>
                                                </div>
                                                <div>
                                                    <Link to={`/product/${item?.product?._id}`} className='btn text-dark'><i className='fa fa-shopping-bag'></i></Link>
                                                    <button className='btn text-danger' onClick={() => deleteItem(item?._id)}><i className='fa fa-trash'></i></button>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                        <hr></hr>
                                    </>
                                }) :
                                <div className='text-center pb-3'>
                                    <h6>No Item In Wishlist</h6>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
